import { defaultThumbnailIcon } from "constants/common";
import ApiUtils from "api/Utils";
import { getCachedData, setCachedData } from "api/Cache";
import { config } from "config";
import { updateData } from "services/CacheService";
import FoldersActions from "./FoldersAction";
import * as Utils from "services/UtilsService";
import { findElement } from "actions/ViewerTools";

export default class ViewsActions {
    static views: any = [];
    static filter: string = "";

    static createView(
        viewName: string,
        viewDesc: string,
        project: string,
        folderId: string,
        done: (viewId: string) => void
    ) {
        ApiUtils.serverCreateId((viewId: string) => {
            let view = {
                ID: viewId,
                entity_container: "",
                file_date: new Date().getTime() + "",
                file_folder: folderId,
                file_type: "VIEW",
                name: viewName,
                project: project,
                state: "COMPLETE",
                thumb: defaultThumbnailIcon,
                type: "FILE",
                view_type: "container",
                description: viewDesc,
            };
            updateData("create", "entities", project, view);
            updateData("create", "views", viewId, view);
            console.log("createView:", viewName, "|", viewId, "|", project);
            done(viewId);
        });
    }

    static saveView(view: any, done: any) {
        const projectId: string = view["project"];
        const entities: any = getCachedData("entities")[projectId];
        var keys = view["entity_container"].split(" ");
        keys = Utils.cleanArray(keys);

        const remoteUpdateViews = () => {
            ApiUtils.remoteUpdateEntity(projectId, view["ID"], view, function (response: any) {
                if (response.result === "success") {
                    //saving the view
                    updateData("save", "views", view["ID"], view);
                    var pending = keys.length;
                    keys.forEach((key: string) => {
                        var subView = entities[key];
                        if (subView.not_selectable) {
                            return;
                        }
                        subView["ID"] = key;
                        subView["project"] = view["project"];
                        subView["type"] = "FILE";
                        subView["file_type"] = "VIEW";
                        subView["state"] = "COMPLETE";
                        subView["file_date"] = new Date().getTime() + "";
                        subView["file_folder"] = FoldersActions.getContainerFolder(projectId, key);
                        subView["virtual"] = "1";
                        ApiUtils.remoteUpdateEntity(projectId, key, subView, function (response: any) {
                            if (response.result === "success") {
                                pending--;
                                if (pending === 0) {
                                    //console.log("saveView:before updateData:", selectedViewContainerProperties);
                                    done(view["ID"]);
                                }
                            }
                        });
                    });
                }
            });
        };

        if (view["thumb"]) {
            // save thumbnail first
            var file = new File([view["thumb"]], "thumbnail.txt");
            ApiUtils.postFileToServer(
                view["project"],
                view["ID"],
                file,
                0,
                () => {
                    remoteUpdateViews();
                },
                () => {}
            );
        } else {
            remoteUpdateViews();
        }
    }

    static createTempView(viewName: string, projectId: string, folder: string, entityContainer: string, callback: any) {
        ApiUtils.serverCreateId((viewId: string) => {
            let view = {
                ID: viewId,
                entity_container: entityContainer,
                file_date: new Date().getTime() + "",
                file_folder: folder,
                file_type: "VIEW",
                name: viewName,
                project: projectId,
                state: "COMPLETE",
                thumb: defaultThumbnailIcon,
                type: "FILE",
                view_type: "container",
            };
            if (Boolean(config.api.filters === "true")) {
                let updateList: any = [];
                let entityContainer: any = view["entity_container"].split(" ");
                entityContainer = Utils.cleanArray(entityContainer);
                entityContainer.forEach((layerId: string) => {
                    const layer = findElement(view.project, layerId);
                    if (layer) {
                        if (layer["view_type"]) {
                            updateList.push(layer["view_type"]);
                        }
                        if (layer["source"]) {
                            updateList.push(layer["source"]);
                        }
                    }
                });
                if (updateList.length > 0) {
                    ApiUtils.getRemoteObjects(updateList, projectId, () => {
                        updateData("create", "entities", projectId, view);
                        updateData("create", "views", viewId, view);
                        callback(view);
                    });
                } else {
                    updateData("create", "views", viewId, view);
                    callback(view);
                }
            } else {
                updateData("create", "entities", projectId, view);
                updateData("create", "views", viewId, view);
                callback(view);
            }
        });
    }

    static deleteEntityList(projectId: string, items: any, done: (response: any) => void) {
        if (items.length > 0) {
            var list = "";
            var count = 0;
            for (var index in items) {
                var i = items[index];
                if (count > 0) list += " ";
                list += i;
                // check if it contains other entities
                var item = getCachedData("entities")[projectId][i];
                if (item && typeof item.entity_container !== "undefined" && item.entity_container.length > 0) {
                    list += " " + item.entity_container;
                }
                count++;
            }

            ApiUtils.remoteDeleteItems(
                projectId,
                list,
                // succeeded
                () => {
                    if (done !== null) done(true);
                },
                // failed
                () => {
                    if (done !== null) done(false);
                }
            );
        }
    }

    static deleteItems(projectId: string, items: any, done: (response: any) => void) {
        ViewsActions.deleteEntityList(projectId, items, (success: any) => {
            if (typeof done !== "undefined" && done !== null) {
                items.forEach((itemId: string) => {
                    updateData("delete", "entities", projectId, { ID: itemId });
                });
                done(success);
            }
        });
    }

    static deleteView(view: any, done: (response: any) => void) {
        var viewId = view.ID;
        var viewName = view.name;
        var projectId = view.project;
        console.log("deleting ", viewName, "|id:", viewId, "from projectId:", projectId);
        var pending = Object.values(getCachedData("pending"));
        const pendingIndex = pending.findIndex((entry: any) => entry.ID === viewId);
        if (pendingIndex > -1) {
            updateData("delete", "entities", projectId, view);
            updateData("delete", "views", viewId, view, () => {
                done(viewId);
            });
        } else {
            var items = [];
            items.push(view.ID);
            ViewsActions.deleteItems(projectId, items, () => {
                updateData("delete", "entities", projectId, view);
                updateData("delete", "views", viewId, view, () => {
                    done(viewId);
                });
            });
        }
    }

    static saveRemoteThumbnail(thumb: string, projectId: string, selectedView: string, done: (response: any) => void) {
        var file = new File([thumb], "thumbnail.txt");
        ApiUtils.postFileToServer(
            projectId,
            selectedView,
            file,
            0,
            () => {
                done(selectedView);
            },
            () => {}
        );
    }

    static findElement(projectId: string, itemId: string) {
        return getCachedData("entities")[projectId][itemId];
    }

    static duplicateView(view: any, done: (response: any) => void) {
        var projectId = view.project;
        const newView = { ...view };
        const cachedData = getCachedData();
        ApiUtils.serverCreateId((newId) => {
            newView.ID = newId;
            newView.name = "Copy of " + view.name;
            var entity_container = "";
            var items = view.entity_container.split(" ");
            var pending = items.length;
            items.forEach((itemId: string) => {
                var entity = cachedData["entities"][projectId][itemId];
                var newEntity = { ...entity };
                ApiUtils.serverCreateId((newItemId) => {
                    newEntity.ID = newItemId;
                    entity_container += newItemId + " ";
                    cachedData["entities"][projectId][newItemId] = newEntity;
                    pending--;
                    if (pending === 0) {
                        newView.entity_container = entity_container.trim();
                        cachedData["entities"][projectId][newId] = newView;
                        cachedData["views"][newId] = newView;
                        setCachedData(cachedData);
                        console.log("****Duplicated view:", view, " with new view:", newView);
                        this.saveView(newView, done);
                    }
                });
            });
        });
    }
}
